export default __webpack_public_path__ + "static/media/puhelin.3dc6e837.svg";